import * as React from 'react'
import { lazyLoad } from '../../../utils/Loadable'
import { LoadingIndicator } from '../../components/LoadingIndicator'
import { Box } from '@mui/material'

export const ArchiveCoursePage = lazyLoad(
    async () => await import('./index'),
    (module) => module.ArchiveCoursePage,
    {
        fallback: (
            <Box
                sx={{
                    width: '100%',
                    height: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <LoadingIndicator />
            </Box>
        )
    }
)
